/// <reference types="vite-plugin-pwa/client" />
import { registerSW } from 'virtual:pwa-register';

// Auto-update do PWA (Breno 2026-06-23): "instalei no iPhone e não atualiza sozinho".
//
// Causa: o registro AUTO-INJETADO do vite-plugin-pwa (quando ninguém chama registerSW)
// só checa por uma nova versão NO LOAD da página. Um PWA INSTALADO fica aberto e, no
// iOS, é reaberto do home sem navegação real → o service worker NUNCA re-checa →
// continua servindo a versão velha do cache mesmo após um novo deploy do front.
//
// Fix: registrar o SW nós mesmos com CHECAGEM ATIVA — poll periódico + ao voltar o
// foco/visibilidade. Como o vite.config usa registerType:'autoUpdate' (+ skipWaiting +
// clientsClaim no workbox), assim que a nova versão é detectada o novo SW assume o
// controle e a página recarrega SOZINHA, sem prompt. Isto só FORÇA a detecção.
const UPDATE_CHECK_INTERVAL_MS = 60 * 1000;

export function setupPwaAutoUpdate(): void {
  if (typeof window === 'undefined' || !('serviceWorker' in navigator)) return;

  registerSW({
    immediate: true,
    onRegisteredSW(_swUrl, registration) {
      if (!registration) return;
      const check = (): void => {
        registration.update().catch(() => {
          /* offline / transitório — tenta de novo no próximo gatilho */
        });
      };
      // Poll enquanto o app está aberto (PWA instalado não re-checa sozinho).
      window.setInterval(check, UPDATE_CHECK_INTERVAL_MS);
      // E sempre que o app volta ao foco — cobre o relaunch do home no iOS.
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') check();
      });
      window.addEventListener('focus', check);
    },
  });
}
